export default __webpack_public_path__ + "static/media/1923.655f4eb7.png";